/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
import { alias } from '@ember/object/computed';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import Scopes from '@linc-technologies/linced-common/enums/scopes';
import { restartableTask } from 'ember-concurrency';
import { classNames } from '@ember-decorators/component';
/**
 * goals-progress-details provides a clickable chip which pops out a goal
 * showcase, explaining the current goal level and which goals have been
 * completed, in progress, or yet to be actioned.
 *
 * Currently goals-progress-details expects categories, subcategories and goals
 * to be present in ember-data from the route.
 * Once the goal list routes have a way to filter the goal data down based on
 * multiple entity IDs, we can thin data down to that which is required.
 */
@classNames('goals-progress-details__chip')
export default class GoalsProgressDetails extends Component {
  @alias('category.badgeMediaId')
  hasBadge;

  Scopes = Scopes;

  // Services
  @service
  permissions;

  @service
  session;

  @service
  store;

  @service
  strings;

  // Props
  // category provides the goal category to generate details for.
  category = null;

  // personId provides the person's identifier.
  personId = '';

  // showCurrentGoalProgress specifies whether the student's current individual
  // goal progress should be displayed to the user.
  showCurrentGoalProgress = false;

  // smallLabel replaces the label chip with a smaller, text-only label.
  smallLabel = false;

  // State
  // progressDialogOpen contains the open state of the progress details dialog.
  @tracked
  progressDialogOpen = false;

  // Methods
  // statesTask loads the learner's current goal states when the dialog opens.
  statesTask = restartableTask(async () => {
    if (!this.showCurrentGoalProgress) {
      // person not entitled to see the student's current state of progress.
      return;
    }

    if (isEmpty(this.personId)) {
      return;
    }

    const query = {
      categoryId: this.get('category.id'),
      current: true,
      personId: this.personId,
      schoolId: this.get('category.school.id'),
      subjectId: this.get('category.subject.id'),
    };
    return await this.store.query('goals/state', query);
  });

  get states() {
    return this.statesTask.lastSuccessful?.value;
  }

  @computed('session.scopes.[]')
  get isTeacher() {
    return this.permissions.meet(Scopes.TENANT_STAFF);
  }

  @computed('isTeacher', 'isParentView')
  get canViewTeacherDescription() {
    return !this.isParentView && this.isTeacher;
  }

  @computed('school.id')
  get progressStrings() {
    return this.strings.getProgressStrings(this.school);
  }

  @action
  openDialog() {
    if (isEmpty(this.category)) {
      return;
    }

    this.progressDialogOpen = !this.progressDialogOpen;
    if (this.progressDialogOpen) {
      this.statesTask.perform();
    }
  }
}
